// import TimeLogUserManagement from "./pages/Work Time Log Management/User Management/UserManagement";
// import UserManagement from "./pages/Invoice Management Module/UserManagement/UserManagement";
// import LeakDectionDashBoard from "./pages/leak detection/Dashboard/LeakDectionDashBoard";
// import FullCalendarComponent from "./pages/Work Time Log Management/Calendar View/FullCalendar";
// import Add_cctv_Checklist from "./pages/CCTV Form/AddCCTVChecklist";
// import View_cctv_checklist from "./pages/CCTV Form/ViewCCTVChecklist";
// import Add_Space_Equipment from "./pages/Space Equipment/AddSpaceEquipment";
// import View_Space_Equipment from "./pages/Space Equipment/ViewSpaceEquipment";
// import Add_Space_Entry_Form from "./pages/Confined Space Entry Form/AddSpaceEntryForm";
// import View_Space_Entry_Form from "./pages/Confined Space Entry Form/ViewSpaceEntryForm";
// import Add_Environmental_Surveying from "./pages/Envirornmental Surveying/AddEnvironmentalSurveying";
// import View_Environmental_Surveying from "./pages/Envirornmental Surveying/ViewEnvironmentalSurveying";
// import AddEquipment_form from "./pages/Equipment Checklist form/AddEquipment_form";
// import ViewEquipment_form from "./pages/Equipment Checklist form/ViewEquipment_form";
// import Add_ConfinedSpacesEquipment from "./pages/Confined Spaces Equipment form/AddConfinedSpacesEquipment";
// import View_ConfinedSpacesEquipment from "./pages/Confined Spaces Equipment form/ViewConfinedSpacesEquipment";
// import AddCCTVChecklist from "./pages/leak detection/CCTV Form/AddCCTVChecklist";
// import ViewCCTVChecklist from "./pages/leak detection/CCTV Form/ViewCCTVChecklist";
// import ViewSpaceEntryForm from "./pages/leak detection/Permit Confined Space Entry Form/ViewPermitSpaceEntryForm";
// import AddSpaceEntryForm from "./pages/leak detection/Permit Confined Space Entry Form/AddPermitSpaceEntryForm";
// import AddSpaceEquipment from "./pages/leak detection/Space Equipment/AddSpaceEquipment";
// import ViewSpaceEquipment from "./pages/leak detection/Space Equipment/ViewSpaceEquipment";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./layout/layout";
import InvoiceManagement from "./pages/Invoice Management Module/InvoiceManagement/InvoiceManagement";
import AddInvoice from "./pages/Invoice Management Module/AddInvoice/AddInvoice";
import SupplierManagement from "./pages/Invoice Management Module/SupplierManagement/SupplierManagement";
import ResetPassword from "./auth/ResetPassword/ResetPassword";
import Login from "./auth/Login";
import ForgetPassword from "./auth/ForgotPassword/ForgetPassword";
import ProtectedRoute from "./ProtectedRoute";
import SetPasswordHandler from "./auth/setPasswordHandler";
import GenerateReport from "./pages/Management Account Module/GenerateReport/GenerateReport";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import NotFound from "./common/NotFound";
import SelectModule from "./pages/SelectModule/SelectModule";
import RolesAndPermissions from "./pages/RolesAndPermissions/RolesAndPermissions";
import { FilterProvider } from "./pages/Invoice Management Module/InvoiceManagement/FiltersContext";
import InvoiceExportHistory from "./pages/Invoice Management Module/InvoiceExportHistory/InvoiceExportHistory";
import TimeLogManagement from "./pages/Work Time Log Management/TimeLog Management/TimeLogManagement";
import VehicleManagement from "./pages/Work Time Log Management/Vehicle Management/VehicleManagement";
import DepartmentManagement from "./pages/Work Time Log Management/Department/DepartmentManagement";
import HolidaysManagement from "./pages/Work Time Log Management/Holidays/HolidaysManagement";
import ProjectManagement from "./pages/Work Time Log Management/Project Management/ProjectManagement";
import Dashboard from "./pages/Invoice Management Module/Dashboard/DashBoard";
import { TLFilterProvider } from "./pages/Work Time Log Management/TimeLog Management/TL_FiltersContext";
import LeakDetection from "./pages/leak detection/LeakDetection";
import AddLeakDetection from "./pages/leak detection/Add Risk Assessment/AddLeakDetection";
import ViewDetection from "./pages/leak detection/ViewDetection";
import LeavesManagement from "./pages/Work Time Log Management/Leaves/LeavesManagement";
import TlDashboard from "./pages/Work Time Log Management/Dashboard/TlDashboard";
import VehicleAssessment from "./pages/leak detection/Vehicle-assessment/VehicleAssessment";
import ViewVehicleAssessment from "./pages/leak detection/Vehicle-assessment/ViewVehicleAssessment";
import VehicleAssessmentListing from "./pages/leak detection/Vehicle-assessment/VehicleAssessmentListing";
import HsFormMapping from "./pages/leak detection/Form Mapping/HsFormMapping";
import HsDashBoard from "./pages/leak detection/Dashboard/HsDashBoard";
import AdminUserManagement from "./pages/Admin Panel/User Management/AdminUserManagement";
import JobsheetBelfastForm from "./pages/leak detection/Job Sheet Belfast/JobsheetBelfastForm";
import EditJobsheetBelfastForm from "./pages/leak detection/Job Sheet Belfast/EditJobsheetBelfastForm";
import JobsheetGloucesterForm from "./pages/leak detection/Job Sheet Gloucester/JobsheetGloucesterForm";
import JobSheetBelFastListing from "./pages/leak detection/Job Sheet Belfast/BelifastFormListing";
import ViewBelifastForm from "./pages/leak detection/Job Sheet Belfast/ViewBelfastForm";
import GloucesterFormListing from "./pages/leak detection/Job Sheet Gloucester/GloucesterFormListing";
import ViewGloucesterForm from "./pages/leak detection/Job Sheet Gloucester/ViewGloucesterForm";
import FormsExportHistory from "./pages/leak detection/Forms Export History/FormsExportHistory";
import EditJobsheetGloucesterForm from "./pages/leak detection/Job Sheet Gloucester/EditJobsheetGloucesterForm";
import ViewEnvironmentalSurveying from "./pages/leak detection/Envirornmental Surveying/ViewEnvironmentalSurveying";
import AddEnvironmentalSurveying from "./pages/leak detection/Envirornmental Surveying/AddEnvironmentalSurveying";
import AddEquipmentform from "./pages/leak detection/Equipment Checklist form/AddEquipmentForm";
import ViewEquipmentform from "./pages/leak detection/Equipment Checklist form/ViewEquipmentForm";
import AddConfinedSpacesEquipment from "./pages/leak detection/Confined Spaces Equipment form/AddConfinedSpacesEquipment";
import ViewConfinedSpacesEquipment from "./pages/leak detection/Confined Spaces Equipment form/ViewConfinedSpacesEquipment";
import AddPermitSpaceEntryForm from "./pages/leak detection/Permit Confined Space Entry Form/AddPermitSpaceEntryForm";
import ViewPermitSpaceEntryForm from "./pages/leak detection/Permit Confined Space Entry Form/ViewPermitSpaceEntryForm";
import PreUseEquipmentCheckListListing from "./pages/leak detection/Equipment Checklist form/PreUseEquipmentCheckListListing";
import ConfinedSpacesEquipmentChecklistListing from "./pages/leak detection/Confined Spaces Equipment form/ConfinedSpacesEquipmentChecklistListing";
import PermitSpaceEntryListing from "./pages/leak detection/Permit Confined Space Entry Form/PermitSpaceEntryListing";
import { PermitSignatureProvider } from "./pages/leak detection/Envirornmental Surveying/PermitSignatureContext";
import EnvironmentalSurveyingListing from "./pages/leak detection/Envirornmental Surveying/EnvironmentSurveyingListing";
import ObserveInformReportListing from "./pages/leak detection/Observe Inform Report/ObserveInformReportListing";
import ViewObserveInformReport from "./pages/leak detection/Observe Inform Report/ViewObserveInformReport";
import PublicObserveInformReport from "./pages/leak detection/Observe Inform Report/PublicObserveInformReport";
import { AddObserveInformReport } from "./pages/leak detection/Observe Inform Report";

function AppRouter() {
  return (
    <>
      {/* <ErrorBoundary></ErrorBoundary> */}
      <Router>
        <DndProvider backend={HTML5Backend}>
          <Routes>
            <Route path="/forgot-password" element={<ForgetPassword />} />
            <Route path="/Reset-Password" element={<ResetPassword />} />
            <Route path="/set-password" element={<SetPasswordHandler />} />
            {/* Public route for QR code access - no authentication required */}
            <Route
              path="/public/observe-inform-report"
              element={<PublicObserveInformReport />}
            />
            <Route
              path="/layout"
              element={
                <FilterProvider>
                  <TLFilterProvider>
                    <PermitSignatureProvider>
                      <Layout />
                    </PermitSignatureProvider>
                  </TLFilterProvider>
                </FilterProvider>
              }
            >
              <Route
                path="roles-and-permissions"
                element={<ProtectedRoute element={<RolesAndPermissions />} />}
              />
              <Route
                path="admin/user-management"
                element={<ProtectedRoute element={<AdminUserManagement />} />}
              />
              <Route
                path="admin/supplier-management"
                element={<ProtectedRoute element={<SupplierManagement />} />}
              />
              <Route
                path="admin/project-management"
                element={<ProtectedRoute element={<ProjectManagement />} />}
              />
              <Route
                path="admin/vehicle-management"
                element={<ProtectedRoute element={<VehicleManagement />} />}
              />
              <Route
                path="admin/holidays"
                element={<ProtectedRoute element={<HolidaysManagement />} />}
              />
              <Route
                path="admin/department"
                element={<ProtectedRoute element={<DepartmentManagement />} />}
              />
              <Route
                path="invoice-management"
                element={<ProtectedRoute element={<InvoiceManagement />} />}
              />
              <Route
                path="add-invoice"
                element={<ProtectedRoute element={<AddInvoice />} />}
              />

              {/* <Route
                path="user-management"
                element={<ProtectedRoute element={<UserManagement />} />}
              /> */}

              <Route
                path="export-history"
                element={<ProtectedRoute element={<InvoiceExportHistory />} />}
              />
              <Route
                path="dashboard"
                element={<ProtectedRoute element={<Dashboard />} />}
              />
              <Route
                path="generate-report"
                element={<ProtectedRoute element={<GenerateReport />} />}
              />
              {/* <Route
                  path="roles-and-permissions"
                  element={<ProtectedRoute element={<RolesAndPermissions />} />}
                /> */}
              {/* <Route
                  path="roles-and-permissions-old"
                  element={<RolesAndPermissionsOldest />}
                /> */}
              <Route
                path="timelog/dashboard"
                element={<ProtectedRoute element={<TlDashboard />} />}
              />
              <Route
                path="timelog-management"
                element={<ProtectedRoute element={<TimeLogManagement />} />}
              />
              <Route
                path="timelog/project-management"
                element={<ProtectedRoute element={<ProjectManagement />} />}
              />
              <Route
                path="timelog/leaves"
                element={<ProtectedRoute element={<LeavesManagement />} />}
              />
              {/* <Route
                path="timelog/user-management"
                element={<ProtectedRoute element={<TimeLogUserManagement />} />}
              /> */}
              <Route
                path="leak-detection/form-mapping"
                element={<ProtectedRoute element={<HsFormMapping />} />}
              />
              <Route
                path="leak-detection/team-listing"
                element={<ProtectedRoute element={<LeakDetection />} />}
              />
              <Route
                path="leak-detection/add-risk-assessment"
                element={<ProtectedRoute element={<AddLeakDetection />} />}
              />
              <Route
                path="leak-detection/view-detection"
                element={<ProtectedRoute element={<ViewDetection />} />}
              />
              <Route
                path="leak-detection/dashboard"
                element={<ProtectedRoute element={<HsDashBoard />} />}
              />
              <Route
                path="leak-detection/add-vehicle-assessment" // add prefix "add-"
                element={<ProtectedRoute element={<VehicleAssessment />} />}
              />
              <Route
                path="leak-detection/view-vehicle-assessment"
                element={<ProtectedRoute element={<ViewVehicleAssessment />} />}
              />
              <Route
                path="leak-detection/vehicle-assessment-list"
                element={
                  <ProtectedRoute element={<VehicleAssessmentListing />} />
                }
              />
              {/* <Route
                path="health-and-safety/add-cctv-checklist"
                element={<ProtectedRoute element={<AddCCTVChecklist />} />}
              />
              <Route
                path="health-and-safety/view-cctv-checklist"
                element={<ProtectedRoute element={<ViewCCTVChecklist />} />}
              /> */}
              {/* <Route
                path="health-and-safety/add-Space-Equipment-checklist"
                element={<ProtectedRoute element={<AddSpaceEquipment />} />}
              />
              <Route
                path="health-and-safety/view-Space-Equipment-checklist"
                element={<ProtectedRoute element={<ViewSpaceEquipment />} />}
              /> */}
              <Route
                path="health-and-safety/environment-surveying"
                element={
                  <ProtectedRoute element={<EnvironmentalSurveyingListing />} />
                }
              />
              <Route
                path="health-and-safety/add-environment-surveying"
                element={
                  <ProtectedRoute element={<AddEnvironmentalSurveying />} />
                }
              />
              <Route
                path="health-and-safety/view-environmental-surveying"
                element={
                  <ProtectedRoute element={<ViewEnvironmentalSurveying />} />
                }
              />
              <Route
                path="health-and-safety/pre-use-equipment-checklist"
                element={
                  <ProtectedRoute
                    element={<PreUseEquipmentCheckListListing />}
                  />
                }
              />
              <Route
                path="health-and-safety/add-equipment-checklist"
                element={<ProtectedRoute element={<AddEquipmentform />} />}
              />
              <Route
                path="health-and-safety/view-equipment-checklist"
                element={<ProtectedRoute element={<ViewEquipmentform />} />}
              />
              <Route
                path="health-and-safety/permit-for-confined-space-entry"
                element={
                  <ProtectedRoute element={<PermitSpaceEntryListing />} />
                }
              />
              <Route
                path="health-and-safety/add-permit-space-entry"
                element={
                  <ProtectedRoute element={<AddPermitSpaceEntryForm />} />
                }
              />
              <Route
                path="health-and-safety/view-permit-space-entry"
                element={
                  <ProtectedRoute element={<ViewPermitSpaceEntryForm />} />
                }
              />
              <Route
                path="health-and-safety/pre-use-confined-space-equipment"
                element={
                  <ProtectedRoute
                    element={<ConfinedSpacesEquipmentChecklistListing />}
                  />
                }
              />
              <Route
                path="health-and-safety/add-confined-spaces-equipment"
                element={
                  <ProtectedRoute element={<AddConfinedSpacesEquipment />} />
                }
              />
              <Route
                path="health-and-safety/view-confined-spaces-equipment"
                element={
                  <ProtectedRoute element={<ViewConfinedSpacesEquipment />} />
                }
              />
              <Route
                path="health-and-safety/add-jobsheet-belfast"
                element={<ProtectedRoute element={<JobsheetBelfastForm />} />}
              />
              <Route
                path="health-and-safety/edit-jobsheet-belfast"
                element={
                  <ProtectedRoute element={<EditJobsheetBelfastForm />} />
                }
              />
              <Route
                path="health-and-safety/jobsheet-belfast"
                element={
                  <ProtectedRoute element={<JobSheetBelFastListing />} />
                }
              />
              <Route
                path="health-and-safety/view-jobsheet-belfast"
                element={<ProtectedRoute element={<ViewBelifastForm />} />}
              />
              <Route
                path="health-and-safety/add-jobsheet-gloucester"
                element={
                  <ProtectedRoute element={<JobsheetGloucesterForm />} />
                }
              />
              <Route
                path="health-and-safety/edit-jobsheet-gloucester"
                element={
                  <ProtectedRoute element={<EditJobsheetGloucesterForm />} />
                }
              />
              <Route
                path="health-and-safety/jobsheet-gloucester"
                element={<ProtectedRoute element={<GloucesterFormListing />} />}
              />
              <Route
                path="health-and-safety/view-jobsheet-gloucester"
                element={<ProtectedRoute element={<ViewGloucesterForm />} />}
              />
              <Route
                path="health-and-safety/forms-export-history"
                element={<ProtectedRoute element={<FormsExportHistory />} />}
              />
              {/* Observe Inform Report Routes */}
              <Route
                path="health-and-safety/observe-inform-report"
                element={
                  <ProtectedRoute element={<ObserveInformReportListing />} />
                }
              />
              <Route
                path="health-and-safety/add-observe-inform-report"
                element={
                  <ProtectedRoute element={<AddObserveInformReport />} />
                }
              />
              <Route
                path="health-and-safety/view-observe-inform-report"
                element={
                  <ProtectedRoute element={<ViewObserveInformReport />} />
                }
              />
            </Route>
            <Route
              path="/layout/select-module"
              element={<ProtectedRoute element={<SelectModule />} />}
            />
            <Route path="/" element={<Login />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </DndProvider>
      </Router>
    </>
  );
}

export default AppRouter;
